import { Outlet } from 'react-router-dom'
import TeamMemberSideNavigation from 'screens/Organisation/components/TeamMemberSideNavigation'
import styled from 'styled-components'

const TeamScreen = () => {
  return (
    <MainContainer data-testid="team-screen">
      <TeamMemberSideNavigation testId="team-screen-navigation" />
      <OutletContainer data-testid="team-screen-content">
        <Outlet />
      </OutletContainer>
    </MainContainer>
  )
}

const MainContainer = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: flex-end;
  margin: 0px auto;
  height: calc(-65px + 100vh);
`

const OutletContainer = styled.div`
  word-wrap: break-word;
  width: 100%;
  overflow-y: auto;
  padding: 0 0 24px;
  max-width: 1080px;
  margin: 0 auto;
`

export default TeamScreen
